export default __webpack_public_path__ + "static/media/invite-img-wrap.eb9af97c.svg";